<div class="chat-icon" *ngIf="chatIconVisible && currentUser">
  <img src="/assets/media/chat-icon.png" alt="Icon Chat" class="icon" />
</div>
